import { BrowserRouter, Route, Routes, Navigate, useParams } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import PortalHomePage from "./pages/PortalHomePage";
import AddUserPage from "./pages/AddUserPage";
import ErrorPage from "./pages/ErrorPage";
import DomaineOvhPage from "./pages/DomaineOvhPage";
import DomaineDetailPage from "./pages/DomaineDetailOVHPage";
import DomaineGandiPage from "./pages/DomaineGandiPage";
import DomaineDetailGandiPage from "./pages/DomaineDetailGandiPage";
import ChiffrageSitePage from "./pages/iti/ChiffrageSitePage";
import ItiMaintenanceMailsPage from "./pages/iti/ItiMaintenanceMailsPage";
import ItiAdminPage from "./pages/iti/ItiAdminPage";
import SiteWebPage from "./pages/SiteWebPage";
import SiteDetailPage from "./pages/SiteDetailPage";
import LoginPage from "./pages/LoginPage";
import GoogleCallbackPage from "./pages/GoogleCallbackPage";
import KlubEtapeMailPage from "./pages/klub/KlubEtapeMailPage";
import UserPage from "./pages/UserPage";
import EditUserPage from "./pages/EditUserPage";
import MenuVisibilityAdminPage from "./pages/MenuVisibilityAdminPage";
import ClientMappingAdminPage from "./pages/admin/ClientMappingAdminPage";
import ClientAnnuairePage from "./pages/admin/ClientAnnuairePage";
import SkillsAdminPage from "./pages/admin/SkillsAdminPage";
import McpDomainsAdminPage from "./pages/admin/McpDomainsAdminPage";
import AllRoutesProtected from "./components/AllRoutesProtected";
import { AppToastContainer } from "./components/common/AppToast";
import { ROUTES } from "./config/routes";
import SecteursCartePage from "./pages/secteurs/SecteursCartePage";
import AgendaDatesPage from "./pages/agenda/AgendaDatesPage";
import AgendaDateFormPage from "./pages/agenda/AgendaDateFormPage";
import SecteursEntreprisesPage from "./pages/secteurs/SecteursEntreprisesPage";
import SecteursEntrepriseDetailPage from "./pages/secteurs/SecteursEntrepriseDetailPage";
import SecteursDashboardPage from "./pages/secteurs/SecteursDashboardPage";
import SecteursAdminHubPage from "./pages/secteurs/admin/SecteursAdminHubPage";
import SecteursAdminSecteursPage from "./pages/secteurs/admin/SecteursAdminSecteursPage";
import SecteursAdminSecteurFormPage from "./pages/secteurs/admin/SecteursAdminSecteurFormPage";
import SecteursAdminZonesPage from "./pages/secteurs/admin/SecteursAdminZonesPage";
import SecteursAdminZoneEditPage from "./pages/secteurs/admin/SecteursAdminZoneEditPage";
import SecteursAdminCommerciauxPage from "./pages/secteurs/admin/SecteursAdminCommerciauxPage";
import SecteursAdminCommercialFormPage from "./pages/secteurs/admin/SecteursAdminCommercialFormPage";
import SecteursAdminEntreprisesPage from "./pages/secteurs/admin/SecteursAdminEntreprisesPage";
import SecteursAdminEntrepriseFormPage from "./pages/secteurs/admin/SecteursAdminEntrepriseFormPage";
import SecteursAdminProduitsSocietePage from "./pages/secteurs/admin/SecteursAdminProduitsSocietePage";
import SecteursAdminProduitsPage from "./pages/secteurs/admin/SecteursAdminProduitsPage";
import SecteursAdminCommandesPage from "./pages/secteurs/admin/SecteursAdminCommandesPage";
import SecteursAdminProduitsCommerciauxPage from "./pages/secteurs/admin/SecteursAdminProduitsCommerciauxPage";
import SecteursAdminEntreprisesProduitsPage from "./pages/secteurs/admin/SecteursAdminEntreprisesProduitsPage";
import SecteursAdminZonePolygonPage from "./pages/secteurs/admin/SecteursAdminZonePolygonPage";
import KkpPlanningMagPage from "./pages/kkp/KkpPlanningMagPage";
import KkpPlanningSetPage from "./pages/kkp/KkpPlanningSetPage";
import KkpDistribPage from "./pages/kkp/KkpDistribPage";
import KkpDistribZonesPage from "./pages/kkp/KkpDistribZonesPage";
import KkpDistribCartePage from "./pages/kkp/KkpDistribCartePage";
import KkpDistribCarteVillesPage from "./pages/kkp/KkpDistribCarteVillesPage";
import KkpDistribCommentairesPage from "./pages/kkp/KkpDistribCommentairesPage";
import KkpDistribLivraisonsPage from "./pages/kkp/KkpDistribLivraisonsPage";
import KkpPlanningNewsletterPage from "./pages/kkp/KkpPlanningNewsletterPage";
import KkpPlanningWebPage from "./pages/kkp/KkpPlanningWebPage";
import KkpCdfMagPage from "./pages/kkp/KkpCdfMagPage";
import KkpPubGraphistePage from "./pages/kkp/KkpPubGraphistePage";
import KkpBilanAudiencePage from "./pages/kkp/KkpBilanAudiencePage";
import KkpSommairePage from "./pages/kkp/KkpSommairePage";
import PlanDeComCalendrierPage from "./pages/kkp/PlanDeComCalendrierPage";
import KkpAdminPage from "./pages/kkp/KkpAdminPage";
import KkpCronsPage from "./pages/kkp/KkpCronsPage";
import KlubDashboardPage from "./pages/klub/KlubDashboardPage";
import KlubListingPage from "./pages/klub/KlubListingPage";
import KlubAdherentDetailPage from "./pages/klub/KlubAdherentDetailPage";
import KlubCeSalariesPage from "./pages/klub/KlubCeSalariesPage";
import KlubAdherentCreatePage from "./pages/klub/KlubAdherentCreatePage";
import KlubCePage from "./pages/klub/KlubCePage";
import KlubCeDashboardPage from "./pages/klub/KlubCeDashboardPage";
import KlubAvisPage from "./pages/klub/KlubAvisPage";
import KlubAdminHubPage from "./pages/klub/admin/KlubAdminHubPage";
import KlubAdminPipelineTemplatePage from "./pages/klub/admin/KlubAdminPipelineTemplatePage";
import KlubChiffragePage from "./pages/klub/KlubChiffragePage";
import KlubMagazinePage from "./pages/klub/KlubMagazinePage";
import TempsTachesPage from "./pages/temps/TempsTachesPage";
import TempsPilotagePage from "./pages/temps/TempsPilotagePage";
import AssistantPage from "./pages/assistant/AssistantPage";
import DepotPage from "./pages/depots/DepotPage";
import { AssistantPageClientProvider } from "./context/AssistantPageClientContext";

const RedirectWithId = ({ basePath }) => {
  const { id } = useParams();
  return <Navigate to={`${basePath}/${id}`} replace />;
};

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AssistantPageClientProvider>
      <RouteScrollToTop />
      <Routes>
        <Route exact path={ROUTES.login} element={<LoginPage />} />
        <Route exact path={ROUTES.googleCallback} element={<GoogleCallbackPage />} />
        <Route path="/klub/etape/:token" element={<KlubEtapeMailPage />} />

        <Route exact path={ROUTES.home} element={
          <AllRoutesProtected>
            <PortalHomePage />
          </AllRoutesProtected>
        } />

        <Route exact path={ROUTES.assistant} element={
          <AllRoutesProtected>
            <AssistantPage />
          </AllRoutesProtected>
        } />

        <Route exact path={ROUTES.depots} element={
          <AllRoutesProtected>
            <DepotPage />
          </AllRoutesProtected>
        } />
        <Route path="/rdv-audio" element={<Navigate to={ROUTES.depots} replace />} />

        <Route path="/iti" element={<Navigate to={ROUTES.iti.domainesOvh} replace />} />
        <Route exact path={ROUTES.iti.domainesOvh} element={
          <AllRoutesProtected>
            <DomaineOvhPage />
          </AllRoutesProtected>
        } />
        <Route exact path="/iti/domaines/ovh/:id" element={
          <AllRoutesProtected>
            <DomaineDetailPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.iti.domainesGandi} element={
          <AllRoutesProtected>
            <DomaineGandiPage />
          </AllRoutesProtected>
        } />
        <Route exact path="/iti/domaines/gandi/:id" element={
          <AllRoutesProtected>
            <DomaineDetailGandiPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.iti.hebergementSites} element={
          <AllRoutesProtected>
            <SiteWebPage />
          </AllRoutesProtected>
        } />
        <Route exact path="/iti/hebergement/sites/:id" element={
          <AllRoutesProtected>
            <SiteDetailPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.iti.chiffrageSite} element={
          <AllRoutesProtected>
            <ChiffrageSitePage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.iti.maintenanceMails} element={
          <AllRoutesProtected>
            <ItiMaintenanceMailsPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.iti.admin} element={
          <AllRoutesProtected>
            <Navigate to={ROUTES.iti.adminSection('variables')} replace />
          </AllRoutesProtected>
        } />
        <Route exact path="/iti/admin/:section" element={
          <AllRoutesProtected>
            <ItiAdminPage />
          </AllRoutesProtected>
        } />
        <Route path="/iti/chiffrage/admin" element={<Navigate to={ROUTES.iti.adminSection('variables')} replace />} />
        <Route path="/iti/chiffrage" element={<Navigate to={ROUTES.iti.chiffrageSite} replace />} />
        <Route path="/iti/chiffrage-site" element={<Navigate to={ROUTES.iti.chiffrageSite} replace />} />

        <Route exact path={ROUTES.secteurs.carte} element={
          <AllRoutesProtected>
            <SecteursCartePage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.agenda.dateNew} element={
          <AllRoutesProtected>
            <AgendaDateFormPage />
          </AllRoutesProtected>
        } />
        <Route exact path="/agenda/dates/:id" element={
          <AllRoutesProtected>
            <AgendaDateFormPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.agenda.dates} element={
          <AllRoutesProtected>
            <AgendaDatesPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.agenda.datesAActiver} element={
          <AllRoutesProtected>
            <AgendaDatesPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.secteurs.entreprises} element={
          <AllRoutesProtected>
            <SecteursEntreprisesPage />
          </AllRoutesProtected>
        } />
        <Route exact path="/secteurs/entreprises/:id" element={
          <AllRoutesProtected>
            <SecteursEntrepriseDetailPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.secteurs.dashboard} element={
          <AllRoutesProtected>
            <SecteursDashboardPage />
          </AllRoutesProtected>
        } />

        <Route exact path={ROUTES.kkp.hub} element={
          <AllRoutesProtected>
            <Navigate to={ROUTES.kkp.planningMag} replace />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.kkp.planningMag} element={
          <AllRoutesProtected>
            <KkpPlanningMagPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.kkp.planningSet} element={
          <AllRoutesProtected>
            <KkpPlanningSetPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.kkp.distribZones} element={
          <AllRoutesProtected>
            <KkpDistribZonesPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.kkp.distribCarte} element={
          <AllRoutesProtected>
            <KkpDistribCartePage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.kkp.distribCarteVilles} element={
          <AllRoutesProtected>
            <KkpDistribCarteVillesPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.kkp.distribCommentaires} element={
          <AllRoutesProtected>
            <KkpDistribCommentairesPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.kkp.distribLivraisons} element={
          <AllRoutesProtected>
            <KkpDistribLivraisonsPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.kkp.distrib} element={
          <AllRoutesProtected>
            <KkpDistribPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.kkp.planningNewsletter} element={
          <AllRoutesProtected>
            <KkpPlanningNewsletterPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.kkp.planningWeb} element={
          <AllRoutesProtected>
            <KkpPlanningWebPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.kkp.cdfMag} element={
          <AllRoutesProtected>
            <KkpCdfMagPage />
          </AllRoutesProtected>
        } />
        <Route path="/kkp/cdf/mag-v2/pub-graphiste" element={<Navigate to={ROUTES.kkp.cdfPubGraphiste} replace />} />
        <Route path="/kkp/cdf/mag-v2" element={<Navigate to={ROUTES.kkp.cdfMag} replace />} />
        <Route exact path={ROUTES.kkp.cdfPubGraphiste} element={
          <AllRoutesProtected>
            <KkpPubGraphistePage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.kkp.bilanAudience} element={
          <AllRoutesProtected>
            <KkpBilanAudiencePage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.kkp.sommaireMag} element={
          <AllRoutesProtected>
            <KkpSommairePage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.kkp.planDeComHub} element={
          <AllRoutesProtected>
            <Navigate to={ROUTES.kkp.planDeCom} replace />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.kkp.planDeCom} element={
          <AllRoutesProtected>
            <PlanDeComCalendrierPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.kkp.bdcSignature} element={
          <AllRoutesProtected>
            <Navigate to={ROUTES.kkp.planDeCom} replace />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.kkp.mediaPlanning} element={
          <AllRoutesProtected>
            <Navigate to={ROUTES.kkp.planDeCom} replace />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.kkp.crons} element={
          <AllRoutesProtected>
            <KkpCronsPage />
          </AllRoutesProtected>
        } />
        <Route path="/kkp/admin/alertes-cdf" element={
          <AllRoutesProtected>
            <Navigate to={ROUTES.kkp.crons} replace />
          </AllRoutesProtected>
        } />
        <Route path="/kkp/admin/plan-de-com" element={
          <AllRoutesProtected>
            <Navigate to={ROUTES.kkp.adminSection('chiffrage')} replace />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.kkp.admin} element={
          <AllRoutesProtected>
            <Navigate to={ROUTES.kkp.adminSection('mag')} replace />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.kkp.adminCommerciaux} element={<Navigate to={ROUTES.admin.commerciaux} replace />} />
        <Route exact path={ROUTES.kkp.adminCommercialNew} element={<Navigate to={ROUTES.admin.commercialNew} replace />} />
        <Route exact path="/kkp/admin/commerciaux/:id" element={<RedirectWithId basePath="/admin/commerciaux" />} />
        <Route exact path="/kkp/admin/:section" element={
          <AllRoutesProtected>
            <KkpAdminPage />
          </AllRoutesProtected>
        } />
        <Route path="/kkp/admin/referentiels" element={<Navigate to={ROUTES.kkp.adminSection('mag')} replace />} />

        <Route exact path={ROUTES.secteurs.admin} element={
          <AllRoutesProtected>
            <SecteursAdminHubPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.secteurs.adminSecteurs} element={
          <AllRoutesProtected>
            <SecteursAdminSecteursPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.secteurs.adminSecteurNew} element={
          <AllRoutesProtected>
            <SecteursAdminSecteurFormPage />
          </AllRoutesProtected>
        } />
        <Route exact path="/secteurs/admin/secteurs/:id" element={
          <AllRoutesProtected>
            <SecteursAdminSecteurFormPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.secteurs.adminZones} element={
          <AllRoutesProtected>
            <SecteursAdminZonesPage />
          </AllRoutesProtected>
        } />
        <Route exact path="/secteurs/admin/zones/:id/polygon" element={
          <AllRoutesProtected>
            <SecteursAdminZonePolygonPage />
          </AllRoutesProtected>
        } />
        <Route exact path="/secteurs/admin/zones/:id" element={
          <AllRoutesProtected>
            <SecteursAdminZoneEditPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.secteurs.adminCommerciaux} element={<Navigate to={ROUTES.admin.commerciaux} replace />} />
        <Route exact path={ROUTES.secteurs.adminCommercialNew} element={<Navigate to={ROUTES.admin.commercialNew} replace />} />
        <Route exact path="/secteurs/admin/commerciaux/:id" element={<RedirectWithId basePath="/admin/commerciaux" />} />
        <Route exact path={ROUTES.secteurs.adminEntreprises} element={
          <AllRoutesProtected>
            <SecteursAdminEntreprisesPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.secteurs.adminEntrepriseNew} element={
          <AllRoutesProtected>
            <SecteursAdminEntrepriseFormPage />
          </AllRoutesProtected>
        } />
        <Route exact path="/secteurs/admin/entreprises/:id" element={
          <AllRoutesProtected>
            <SecteursAdminEntrepriseFormPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.secteurs.adminProduitsSociete} element={
          <AllRoutesProtected>
            <SecteursAdminProduitsSocietePage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.secteurs.adminProduits} element={
          <AllRoutesProtected>
            <SecteursAdminProduitsPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.secteurs.adminCommandes} element={
          <AllRoutesProtected>
            <SecteursAdminCommandesPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.secteurs.adminProduitsCommerciaux} element={
          <AllRoutesProtected>
            <SecteursAdminProduitsCommerciauxPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.secteurs.adminEntreprisesProduits} element={
          <AllRoutesProtected>
            <SecteursAdminEntreprisesProduitsPage />
          </AllRoutesProtected>
        } />

        <Route exact path={ROUTES.klub.dashboard} element={
          <AllRoutesProtected>
            <KlubDashboardPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.klub.adherents} element={
          <AllRoutesProtected>
            <KlubListingPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.klub.adherentNew} element={
          <AllRoutesProtected>
            <KlubAdherentCreatePage />
          </AllRoutesProtected>
        } />
        <Route exact path="/klub/adherents/:id/salaries" element={
          <AllRoutesProtected>
            <KlubCeSalariesPage />
          </AllRoutesProtected>
        } />
        <Route exact path="/klub/adherents/:id" element={
          <AllRoutesProtected>
            <KlubAdherentDetailPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.klub.ce} element={
          <AllRoutesProtected>
            <KlubCeDashboardPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.klub.ceListe} element={
          <AllRoutesProtected>
            <KlubCePage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.klub.avis} element={
          <AllRoutesProtected>
            <KlubAvisPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.klub.chiffrage} element={
          <AllRoutesProtected>
            <KlubChiffragePage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.klub.magazine} element={
          <AllRoutesProtected menuKey="page.klub.magazine">
            <KlubMagazinePage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.klub.admin} element={
          <AllRoutesProtected>
            <KlubAdminHubPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.klub.adminPipeline} element={
          <AllRoutesProtected>
            <KlubAdminPipelineTemplatePage />
          </AllRoutesProtected>
        } />

        <Route exact path={ROUTES.admin.users} element={
          <AllRoutesProtected>
            <UserPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.admin.usersAdd} element={
          <AllRoutesProtected>
            <AddUserPage />
          </AllRoutesProtected>
        } />
        <Route exact path="/admin/users/edit/:id" element={
          <AllRoutesProtected>
            <EditUserPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.admin.menuVisibility} element={
          <AllRoutesProtected>
            <MenuVisibilityAdminPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.admin.clients} element={
          <AllRoutesProtected>
            <ClientAnnuairePage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.admin.clientMapping} element={
          <AllRoutesProtected>
            <ClientMappingAdminPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.admin.skills} element={
          <AllRoutesProtected>
            <SkillsAdminPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.admin.mcpDomains} element={
          <AllRoutesProtected>
            <McpDomainsAdminPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.admin.commerciaux} element={
          <AllRoutesProtected>
            <SecteursAdminCommerciauxPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.admin.commercialNew} element={
          <AllRoutesProtected>
            <SecteursAdminCommercialFormPage />
          </AllRoutesProtected>
        } />
        <Route exact path="/admin/commerciaux/:id" element={
          <AllRoutesProtected>
            <SecteursAdminCommercialFormPage />
          </AllRoutesProtected>
        } />

        {/* Redirections depuis les anciennes URLs */}
        <Route path="/domaine-ovh/:id" element={<RedirectWithId basePath="/iti/domaines/ovh" />} />
        <Route path="/domaine-ovh" element={<Navigate to={ROUTES.iti.domainesOvh} replace />} />
        <Route path="/domaine-gandi/:id" element={<RedirectWithId basePath="/iti/domaines/gandi" />} />
        <Route path="/domaine-gandi" element={<Navigate to={ROUTES.iti.domainesGandi} replace />} />
        <Route path="/hebergement/site/:id" element={<RedirectWithId basePath="/iti/hebergement/sites" />} />
        <Route path="/hebergement/sites" element={<Navigate to={ROUTES.iti.hebergementSites} replace />} />
        <Route path="/users/edit/:id" element={<RedirectWithId basePath="/admin/users/edit" />} />
        <Route path="/users/add" element={<Navigate to={ROUTES.admin.usersAdd} replace />} />
        <Route path="/users" element={<Navigate to={ROUTES.admin.users} replace />} />

        <Route exact path={ROUTES.temps.taches} element={
          <AllRoutesProtected>
            <TempsTachesPage />
          </AllRoutesProtected>
        } />
        <Route exact path={ROUTES.temps.pilotage} element={
          <AllRoutesProtected>
            <TempsPilotagePage />
          </AllRoutesProtected>
        } />
        <Route path="/temps/projets/*" element={<Navigate to={ROUTES.temps.taches} replace />} />
        <Route exact path="/temps/projets" element={<Navigate to={ROUTES.temps.taches} replace />} />

        <Route exact path='*' element={
          <AllRoutesProtected>
            <ErrorPage />
          </AllRoutesProtected>
        } />
      </Routes>
      <AppToastContainer />
      </AssistantPageClientProvider>
    </BrowserRouter>
  );
}

export default App;
